<div class="content">
  <app-header (logout)='logOut()'
              (chantierSelected)="onChantierSelected($event)"
              [selectedChantier]="selectedChantier$ | async"
              [selectableUserChantiers]="selectableUserChantiers$ | async"
              [logoHeuresInsertionUrl]="logoHeuresInsertionUrl"
              [connectedUser]="connectedUser$ | async"></app-header>
  <div class="container">
    <router-outlet></router-outlet>
  </div>
  <app-footer
    [logoUrl]="logoFooterUrl"
    [backendVersion]='backendVersion$ | async'
  />
</div>

